import { defineMessages } from 'react-intl';

/**
 * The copy of the YouTube settings section (design music24-composer-tiktok, frames c). The section
 * follows the YouTube API Services Terms and the audit of the app: the user picks the privacy
 * status and answers "Made for kids", and the page links the YouTube Terms and the Google Privacy
 * Policy.
 */
export const youtubeMessages = defineMessages({
  title: { id: 'app.sml.promote.composer.youtube.title', defaultMessage: 'YouTube settings' },
  tag: { id: 'app.sml.promote.composer.youtube.tag', defaultMessage: 'Upload' },
  postingTo: { id: 'app.sml.promote.composer.youtube.postingTo', defaultMessage: 'Uploading to' },
  privacyLabel: { id: 'app.sml.promote.composer.youtube.privacy.label', defaultMessage: 'Who can see this video' },
  privacyPlaceholder: {
    id: 'app.sml.promote.composer.youtube.privacy.placeholder',
    defaultMessage: 'Choose who can see it',
  },
  privacyPublic: { id: 'app.sml.promote.composer.youtube.privacy.public', defaultMessage: 'Public' },
  privacyUnlisted: { id: 'app.sml.promote.composer.youtube.privacy.unlisted', defaultMessage: 'Unlisted' },
  privacyPrivate: { id: 'app.sml.promote.composer.youtube.privacy.private', defaultMessage: 'Private' },
  kidsLabel: { id: 'app.sml.promote.composer.youtube.kids.label', defaultMessage: 'Is this video made for kids?' },
  kidsYes: { id: 'app.sml.promote.composer.youtube.kids.yes', defaultMessage: 'Yes, it is made for kids' },
  kidsNo: { id: 'app.sml.promote.composer.youtube.kids.no', defaultMessage: 'No, it is not made for kids' },
  kidsNote: {
    id: 'app.sml.promote.composer.youtube.kids.note',
    defaultMessage: 'YouTube asks this for every video. You decide, not MUSIC24.',
  },
  kidsLearnMore: { id: 'app.sml.promote.composer.youtube.kids.learnMore', defaultMessage: 'Learn more' },
  titleNote: {
    id: 'app.sml.promote.composer.youtube.titleNote',
    defaultMessage: 'The first line of the caption is the title of the video.',
  },
  consent: {
    id: 'app.sml.promote.composer.youtube.consent',
    defaultMessage:
      'By posting, you agree to the <terms>YouTube Terms of Service</terms> and the <privacy>Google Privacy Policy</privacy>. MUSIC24 uses YouTube API Services.',
  },
  needsPrivacy: {
    id: 'app.sml.promote.composer.youtube.needsPrivacy',
    defaultMessage: 'Choose who can see this video to publish it.',
  },
  needsKids: {
    id: 'app.sml.promote.composer.youtube.needsKids',
    defaultMessage: 'Say if the video is made for kids to publish it.',
  },
});
